import React, { Component } from 'react';
import SPurchaseSucceeded from 'shared/screens/PurchaseSucceeded';
import { getText, TEXT_KEY } from 'shared/utils/localization';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { headerContainerStyle } from './components/styledComponents';
import Button from '../../components/Button/Button';
import PurhaseResultHeader from './components/PurchaseResultHeader';
import { PromoActionKey } from 'shared/utils/PromotionAction';

export default class PurchaseSucceeded extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-purchase-succeeded',
      dismissPromoAction: PromoActionKey.GO_TO_COIN_STORE,
    };
  }

  render() {
    return (
      <SPurchaseSucceeded
        navigation={this.props.navigation}
        {...this.props}
        render={args => {
          const { message, buttonHandler, vipPurchase } = args;

          return (
            <div qa-id="purchaseSuccess" className="SuccessMessageContainer">
              {!vipPurchase && (
                <>
                  <PurhaseResultHeader
                    containerStyle={headerContainerStyle}
                    title={getText(TEXT_KEY.PURCHASE_SUCCESSFUL)}
                  />

                  <img
                    src={assetSource(ASSET_KEY.PILE_OF_COINS)}
                    style={{
                      width: '55%',
                      height: '60%',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                  <div className="successHeader">{getText(TEXT_KEY.SUCCESS_RESPONSE)}</div>
                </>
              )}
              {vipPurchase && (
                <>
                  <img
                    className="congratulationsImage"
                    alt="Purchase succeeded"
                    src={assetSource(ASSET_KEY.PURCHASE_SUCCEEDED)}
                  />
                  <div style={{ position: 'relative', width: '100%', marginBottom: '1rem' }}>
                    <img
                      alt=""
                      src={assetSource(ASSET_KEY.LIGHT_DIVIDER)}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        pointerEvents: 'none',
                      }}
                    />
                  </div>
                </>
              )}
              <div className="messageContainer">
                {vipPurchase && <div className="message">{getText(TEXT_KEY.ACCESS_GRANTED)}</div>}
                <div className="message">{message}</div>
              </div>
              <Button
                imageSource={assetSource(ASSET_KEY.ROUNDED_RECT_PRIMARY)}
                label={vipPurchase ? getText(TEXT_KEY.PLAY_BUTTON) : getText(TEXT_KEY.DONE)}
                onClick={buttonHandler}
                containerStyle={{ padding: '2rem' }}
                imageStyle={{
                  cursor: 'pointer',
                }}
              />
            </div>
          );
        }}
      />
    );
  }
}

PurchaseSucceeded.hideCloseButton = false;

